"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetitivePriceParamsSchema = exports.CompetitivePriceSchema = exports.AttributePriceSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.AttributePriceSchema = zod_1.z.object({
    landedPrice: __1.MoneySchema,
    productPrice: __1.MoneySchema,
    shippingPrice: __1.MoneySchema,
});
exports.CompetitivePriceSchema = zod_1.z.object({
    channel: __1.ChannelSchema.partial().required({ id: true }),
    channelOfferMaxPriceUrl: __1.LongStringSchema.url(),
    channelOfferMinPriceUrl: __1.LongStringSchema.url(),
    maxPrice: exports.AttributePriceSchema,
    minPrice: exports.AttributePriceSchema,
});
exports.CompetitivePriceParamsSchema = zod_1.z.object({
    identifier: __1.ShortStringSchema,
    itemCondition: zod_1.z.nativeEnum(__1.ItemCondition),
    storeCountryCode: zod_1.z.nativeEnum(__1.Alpha3Countries).optional(),
});
//# sourceMappingURL=competitive-price.js.map